import { render, staticRenderFns } from "./cryptoDeposit.vue?vue&type=template&id=bb1242da&scoped=true"
import script from "./cryptoDeposit.vue?vue&type=script&lang=js"
export * from "./cryptoDeposit.vue?vue&type=script&lang=js"
import style0 from "./cryptoDeposit.vue?vue&type=style&index=0&id=bb1242da&prod&lang=scss"
import style1 from "./cryptoDeposit.vue?vue&type=style&index=1&id=bb1242da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1242da",
  null
  
)

export default component.exports